import { render, staticRenderFns } from "./call-record.vue?vue&type=template&id=060831a4"
import script from "./call-record.vue?vue&type=script&lang=js"
export * from "./call-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports